import { writable } from "svelte/store";

export const assetLockState = writable({});
